import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { HelpConfig } from '../../molecules/help-icon/models/help-icon.interfaces';
import { ErrorTooltipHelperComponent } from './error-tooltip-helper.component';
@Component({
  selector: 'idp-error-tooltip',
  templateUrl: './error-tooltip.component.html',
  styleUrls: ['./error-tooltip.component.scss']
})
/**
 * Note: Directive TooltipPosition needs to be used with this component
 * to position the tooltip properly
 */
export class ErrorTooltipComponent
  extends ErrorTooltipHelperComponent
  implements OnInit, AfterViewInit
{
  @Input() errorMessage = '';
  @Input() icon = false;
  @Input() formCtrlId = '';
  @Input() closeIcon = false;
  @Input() hasLink = false;
  @Input() focus = false;
  @Input() index = -1;
  @Input() arrowPosition = 'right';
  @Input() infoToolTip = false;
  @Input() closeEscInfoToolTip = false;
  @Input() tooltipPosition = '';
  @Input() config = {} as HelpConfig;
  @Output() closePopUp: EventEmitter<void> = new EventEmitter();
  @Output() closeFullPopUp: EventEmitter<Event> = new EventEmitter();
  @Output() focusoutInfoToolTip: EventEmitter<Event> = new EventEmitter();
  @ViewChild('tooltip') tooltipRef!: ElementRef;
  @ViewChild('tooltipWrapper') tooltipWrapperRef!: ElementRef;

  parentHeight = 0;
  parentWidth = 0;
  tooltipHeight = 0;
  tooltipWidth = 0;
  top = '';
  left = '';
  tooltipContent = false;

  constructor(
    private elementRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit() {
    this.parentHeight =
      this.elementRef.nativeElement.parentElement.offsetHeight;
    this.parentWidth = this.elementRef.nativeElement.parentElement.offsetWidth;
  }

  ngAfterViewInit() {
    if (this.tooltipRef) {
      this.tooltipHeight = this.tooltipRef.nativeElement.offsetHeight;
      this.tooltipWidth = this.tooltipRef.nativeElement.offsetWidth;
      this.left = this.parentWidth / 2 - this.tooltipWidth / 2 + 'px';
      this.top = this.tooltipHeight * -1 + 'px';
    }
    this.focusOnToolTipWrapper();
    if (this.config.focusTooltip) {
      this.focusTooltipContent(
        document.getElementsByClassName('idp-error-tooltip__wrapper')
      );
    }
    this.changeDetectorRef.detectChanges();
  }

  focusOnToolTipWrapper = (): void => {
    if (this.focus) {
      const tooltipWrapperRef = this.elementRef.nativeElement.querySelector(
        '#tooltipWrapper' + this.index
      );
      if (tooltipWrapperRef) {
        tooltipWrapperRef.focus();
      }
    }
  };

  @HostListener('document:click', ['$event'])
  clickout(event: Event) {
    const eventTarget = event.target as HTMLElement;

    if (this.isDialogRelatedEvent(eventTarget)) {
      event.stopPropagation();
      return;
    }

    if (this.isOutsideClick(eventTarget)) {
      this.closePopupOver(event);
    }
  }

  isOutsideClick(target: any) {
    return !this.containsElement(target) && !this.isInfoIcon(target);
  }

  /**
   * On FocusOut of Info ToolTip close icon emits event,captured at parent for closing toolTip per AX criteria
   * For Angular SSR builds, we should not be adding data types in the function parameters,since those types like HTMLElement are not available in SSR mode
   */
  @HostListener('focusout', ['$event.target'])
  onFocusout() {
    setTimeout(() => {
      if (this.tooltipContent) {
        this.tooltipContent = false;
      } else if (this.closeIcon && this.hasLink) {
        this.focusOnToolTipWrapper();
      } else if (this.closeIcon) {
        this.focusoutInfoToolTip.emit();
        setTimeout(() => {
          this.focusOnToolTipWrapper();
        });
      } else {
        this.focusoutInfoToolTip.emit();
      }
    });
  }

  containsElement(target: HTMLElement): boolean {
    return (
      this.elementRef.nativeElement.contains(target) ||
      this.containedInIconButton(target) ||
      this.containsInHelpIcon(target)
    );
  }

  closeIconFocus() {
    this.tooltipContent = true;
  }

  closePopupOver(input: Event) {
    this.closePopUp.emit();
    this.closeFullPopUp.emit(input);
  }

  handlingEscape(): void {
    if (this.closeEscInfoToolTip) {
      this.closePopUp.emit();
    }
  }
}
